import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.dashboard,
    element: <Loadable component={() => import('./pages/DashboardPage')} />,
  },
];
